// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"0":"chunk-delete-account","1":"chunk-newsletters-bar"}[chunkId] + "." + {"0":"2dd3fc05a821d69d89d3","1":"2d73c150ea248d19a6fa"}[chunkId] + ".js";
};